import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const DiscussionsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[28%] left-[8%] w-[80%] rounded-xl p-4 bg-white overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-x-0 opacity-30' : 'translate-x-4 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/discussions/2.jpg"
               alt="Forum"
            />
         </div>
         <div
            className={classNames(
               'absolute top-[10%] left-[25%] w-[65%] h-[900px] bg-cyan-950 rounded-xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.2)] transition-all duration-700 delay-50',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-6 opacity-0'
            )}>
            <div className="bg-white px-8 py-8">
               <img
                  className="w-full"
                  src="/assets/custom/communities/images/features/discussions/1.jpg"
                  alt="Forum"
               />
            </div>
         </div>
      </div>
   )
}

DiscussionsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default DiscussionsFeature
